import React, {useState, useEffect} from "react";
import Close from "../img/Close.svg";
import Delete from "../img/Delete.svg";
import { useShopContext } from "../contexts/ShopContext";
import ReactModal from "react-modal";
import QRDragsmark from '../img/DragsmarkSwish.png'
import QRLingall from '../img/LingallSwish.png'
import { database } from "../firebase"


export default function Modal() {
  const [ShowQRCode, setShowQRCode] = useState(false);
  const shopCart = useShopContext();

 
  const Push = () => {
    
   // var key = myRef.key;
    var AtSimskola = shopCart.IsDragsmark ? 'Dragsmark' : 'Lingall';
    var time = Date.now()
    var soldPins = {};
    for(var i in PinList){
      var pinKey = 'Pin'+i
      soldPins[pinKey] = {id:PinList[i].PinId, price:PinList[i].PinPrice} 
    }


    var newData={
        Price: TotalPrice,
        PinsSold: soldPins,
        Time : time,
        simskola : AtSimskola
    }
    database.ref('/transactions').child(AtSimskola).push(newData);
    //myRef.push(newData);
    shopCart.ClearItems();
    shopCart.SetShowModal(false);
  }
  
  
function LoadQRCode(){
  setShowQRCode(ShowQRCode => !ShowQRCode)
}
  
  var TotalPrice = 0;
  var PinList =[];
  console.log(shopCart.ShopCart.length," SC lenght")
  for (let i = 0; i < shopCart.ShopCart.length; i++) {
    TotalPrice += parseInt(shopCart.ShopCart[i].PinPrice);
    PinList.push(shopCart.ShopCart[i]);
  }
  //PinList = PinList.map((Pin) => (<div className="PinlistItem">{Pin.Name} {Pin.Price}</div>));
  const currentDate = new Date();
  const timestamp = currentDate.getTime();
  var PinListDisplay = PinList.map((Pin,index) => (<div key={index} className="PinlistItem">
                        <div className="PinlistItemName">
                          <img className="PinlistItemImg" src={require('../img/Pins/'+Pin.PinId+'.png')}></img>
                          <div>{Pin.PinName}</div>
                        </div>
                        <div className="PinlistItemBox">
                          L1
                        </div>
                        <div className="PinlistItemPrice">
                          {Pin.PinPrice}kr
                        </div>
                        <img onClick={() => shopCart.RemoveItem(Pin.PinId)} className="PinlistItemDel" src={Delete}></img>
                      </div>)
                      );

  function RemoveItem(pinType){
    
  }

  return (
    <ReactModal
    isOpen={shopCart.ShowModal}
    ariaHideApp={false}
    style={{
      overlay: {backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex:'20'},
      content: {
        top: "5em",
        bottom: "1em",
        right: ".5em",
        left: ".5em",
        padding: 0,
        maxWidth: '400px',
        margin: 'auto',
        borderRadius: '8px'
      },
    }}
  >
    <div className="Modal">
     <div className="ModalTop">
  <div className="Price">
    <div className="PriceText">
      Pris: {TotalPrice} kr
    </div>
  </div>
  <div className="exitModal" onClick={() =>{shopCart.SetShowModal(false)}}><img src={Close}></img></div>
</div>

<br />
<div className="ListTitle">Märken:</div>
<div className="PinList">
  {PinListDisplay}
</div>
<br />
<div className="ModalButtonsContainer">
  <div className="ModalButtons" onClick={()=>LoadQRCode()}><div>QR Kod</div></div>
  <div className="ModalButtons" onClick={Push}><div>Slutför</div></div>
  {ShowQRCode && <img className="QRCode" src={shopCart.IsDragsmark ? QRDragsmark : QRLingall}></img>}
</div>
</div>
</ReactModal> 

  );
}
